export class WarehouseBankApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getWarehouseBanks() {
    return this.#http.get('/WarehouseBank');
  }

  async getWarehouseBankList(params) {
    return this.#http.get('/WarehouseBank/list', { params });
  }

  async createWarehouseBank(body) {
    return this.#http.post('/WarehouseBank', body);
  }

  async editWarehouseBank({ warehouseBankId, ...body }) {
    return this.#http.put(`/WarehouseBank/${warehouseBankId}`, body);
  }

  async deleteWarehouseBank({ warehouseBankId }) {
    return this.#http.delete(`/WarehouseBank/${warehouseBankId}`);
  }
}
